export const ENABLED_BACK_TO_EMBED_DASHBOARD = 'enabledBackToEmbedDashboard';
export const BUILDER_OPEN_NEW_TAB = 'builderOpenNewTab';
